import { useTranslation } from "react-i18next";
import { EducationLeftMenuList } from "../utils/constants";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";

const Kmc_school_home = () => {
  const { t } = useTranslation();

  return (
    <CommonPageUiLayer leftNavsList={EducationLeftMenuList}>
      <div className="container">
        <div className="row">
          <div className="inner-title">
            <h3> {t("KMCP Schools")} </h3>
          </div>
          <div className="font-italic text-danger">
            {t(
              "Information about KMC Primary School along with Schemes for the benefit of the Students"
            )}
          </div>
          <div className="my-3">
            <strong>
              {t("VARIOUS INFORMATION REGARDING KMC PRIMARY SCHOOL")}
            </strong>
          </div>
          <div id="accordion">
            <div className="card">
              <div className="card-header" id="heading1">
                <button
                  className="btn btn-link m-2"
                  data-toggle="collapse"
                  data-target="#collapse1"
                  aria-expanded="true"
                  aria-controls="collapse1"
                >
                  1.
                  {t(
                    "No. of KMCP Schools at present are 263 including three streams i.e. Bengali, Hindi and Urdu (Boys & Girls)"
                  )}
                  .
                </button>
              </div>
              <div
                id="collapse1"
                className="collapse show"
                data-parent="#accordion"
              >
                <div className="card-body m-3">
                  <ul className="kmc-function-list">
                    {[
                      "No. of Bengali Medium Schools are 154",
                      "No. of Hindi Medium Schools are 46",
                      "No. of Urdu Medium Schools are 56",
                      "No. of Mixed (Bengali & Urdu) Medium Schools are 5",
                      "No. of Mixed (Hindi & Urdu) Medium Schools are 2",
                    ].map((item, index) => (
                      <li key={index}>{t(item)}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading2">
                <button
                  className="btn btn-link m-2"
                  data-toggle="collapse"
                  data-target="#collapse2"
                  aria-expanded="true"
                  aria-controls="collapse2"
                >
                  2. {t("Stream wise present No. of teachers:")}
                </button>
              </div>
              <div id="collapse2" className="collapse" data-parent="#accordion">
                <div className="card-body m-3">
                  <ul className="kmc-function-list">
                    {[
                      "Bengali Medium - 328",
                      "Hindi Medium - 100",
                      "Urdu Medium - 111",
                      "Mixed (Bengali & Urdu) - 18",
                      "Mixed (Hindi & Urdu) - 12",
                      "Music Teachers - 6",
                      "Craft Teachers - 7",
                    ].map((item, index) => (
                      <li key={index}>{t(item)}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading3">
                <button
                  className="btn btn-link m-2"
                  data-toggle="collapse"
                  data-target="#collapse3"
                  aria-expanded="true"
                  aria-controls="collapse3"
                >
                  3. {t("Stream wise present no. of Students:")}
                </button>
              </div>
              <div id="collapse3" className="collapse" data-parent="#accordion">
                <div className="card-body m-3">
                  <ul className="kmc-function-list">
                    {[
                      "Bengali Medium: 13338",
                      "Hindi Medium: 5611",
                      "Urdu Medium: 8681",
                      "Mixed (Bengali & Urdu): 681",
                      "Mixed (Hindi & Urdu): 442",
                      "Total No. of Students: 26971",
                    ].map((item, index) => (
                      <li key={index}>{t(item)}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading4">
                <button
                  className="btn btn-link m-2"
                  data-toggle="collapse"
                  data-target="#collapse4"
                  aria-expanded="true"
                  aria-controls="collapse4"
                >
                  4.
                  {t(
                    "With the Financial assistance of Govt. of West Bengal K.M.C is organizing 102 centres of Child education (S.S.K) between 01 to 141 Ward in different streams."
                  )}
                </button>
              </div>
              <div id="collapse4" className="collapse" data-parent="#accordion">
                <div className="card-body m-3">
                  <ul className="kmc-function-list">
                    {[
                      "Bengali Medium: 72 Centres",
                      "Hindi Medium: 10 Centres",
                      "Urdu Medium: 17 Centres",
                      "Oria Medium: 01 Centre",
                    ].map((item, index) => (
                      <li key={index}>{t(item)}</li>
                    ))}
                  </ul>
                  204 Assistance and two Inspectors have been engaged for the
                  aforesaid Centres.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading5">
                <button
                  className="btn btn-link m-2"
                  data-toggle="collapse"
                  data-target="#collapse5"
                  aria-expanded="true"
                  aria-controls="collapse5"
                >
                  5.
                  {t(
                    "The following schemes have been undertaken in KMCP Schools for the benefit of KMCP School Children and / or the children of the neighbouring areas."
                  )}
                </button>
              </div>
              <div id="collapse5" className="collapse" data-parent="#accordion">
                <div className="card-body m-3">
                  <ul className="kmc-function-list">
                    {[
                      "Annual Sports meet of KMCP School Children",
                      "Participation in State Level Sports on regular basis",
                      "Distribution of national text books amongst the children of KMCP Schools and S.S.K. on free of cost",
                      "Libraries for students",
                      "Participation in integrated learning project evaluation through Sarva Siksha Abhiyan (S.S.A.)",
                      "Various training programme for development of scientific concepts of the children of KMCP Schools are arranged by Education Department, K.M.C with the financial assistance of UNICEF",
                      "Celebration of International Literacy Day on 8th September every year",
                      "Distribution of School Uniforms",
                      "Distribution of academic prizes and sport prizes",
                      "Distribute Mid-day-meal to all students of KMCP schools",
                      "Celebration of auspicious days namely Netaji's Birthday, Republic Day, Rabindra Jayanti, Independence Day etc",
                      "Participation of School Children in sit & draw programme",
                      "Participation of school children in educational tour to places of Historical interest",
                      "Arrangement of school wise exhibition on improvised models",
                      "Work Education and Physical Education",
                    ].map((item, index) => (
                      <li key={index}>{t(item)}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

export default Kmc_school_home;
